module.exports = __webpack_public_path__ + "img/mBank.95506587.png";